import type {
  UserActionHistoryResponse
} from '@coorum-research/shared-common/api-response/user-action-history.schema'
import {
  type CreateUserActionHistoryValues,
} from '@coorum-research/shared-common/types/user-action-histories.type'
import http from './http'

export const userActionHistoryApi = () => {
  const createUserActionHistory = async (data: CreateUserActionHistoryValues): Promise<UserActionHistoryResponse> => {
    const response = await http.post(`/user-action-histories`, data)
    return response.data
  }

  return {
    createUserActionHistory,
  }
}
